import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_FILE {
  NAME_AND_FILE,
  HEADER,
  DATA_TYPE,
  MAP_COLUMNS,
  CONFIRMATION,
}

export const CREATE_DATA_SOURCE_FILE_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_FILE.NAME_AND_FILE,
    title: 'data_source_edit:file.steps.name_and_file',
  },
  {
    id: CREATE_DATA_SOURCE_FILE.HEADER,
    title: 'data_source_edit:file.steps.header',
  },
  {
    id: CREATE_DATA_SOURCE_FILE.DATA_TYPE,
    title: 'data_source_edit:file.steps.data_type',
  },
  {
    id: CREATE_DATA_SOURCE_FILE.MAP_COLUMNS,
    title: 'data_source_edit:file.steps.map_columns',
  },
  {
    id: CREATE_DATA_SOURCE_FILE.CONFIRMATION,
    title: 'data_source_edit:file.steps.confirmation',
  },
];

export const DEFAULT_HEADER = 'defaultHeader';
export const ITEM_HEADER = 'itemHeader';
